import { render, staticRenderFns } from "./VaTabs.vue?vue&type=template&id=7430be4f&"
import script from "./VaTabs.vue?vue&type=script&lang=js&"
export * from "./VaTabs.vue?vue&type=script&lang=js&"
import style0 from "./VaTabs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports